// A sticky-note node with no handles — just for documenting pipelines
import { useState } from 'react';
import { BaseNode, NodeTextarea } from './baseNode';

export const NoteNode = ({ data }) => {
  const [note, setNote] = useState(data?.note || 'Add a note...');

  return (
    <BaseNode label="Note" color="#84cc16" handles={[]}>
      <NodeTextarea
        rows={4}
        value={note}
        onChange={e => setNote(e.target.value)}
        placeholder="Write a note about this pipeline..."
        style={{ background: '#f7fee7', borderColor: '#d9f99d' }}
      />
    </BaseNode>
  );
};